/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateRangeFilter
 */
export interface DateRangeFilter {
    /**
     * Optional lower date value.
     * @type {Date}
     * @memberof DateRangeFilter
     */
    startAt?: Date | null;
    /**
     * Optional upper date value.
     * @type {Date}
     * @memberof DateRangeFilter
     */
    endAt?: Date | null;
}

/**
 * Check if a given object implements the DateRangeFilter interface.
 */
export function instanceOfDateRangeFilter(value: object): value is DateRangeFilter {
    return true;
}

export function DateRangeFilterFromJSON(json: any): DateRangeFilter {
    return DateRangeFilterFromJSONTyped(json, false);
}

export function DateRangeFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateRangeFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'startAt': json['startAt'] == null ? undefined : (new Date(json['startAt'])),
        'endAt': json['endAt'] == null ? undefined : (new Date(json['endAt'])),
    };
}

export function DateRangeFilterToJSON(json: any): DateRangeFilter {
    return DateRangeFilterToJSONTyped(json, false);
}

export function DateRangeFilterToJSONTyped(value?: DateRangeFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startAt': value['startAt'] === null ? null : ((value['startAt'] as any)?.toISOString()),
        'endAt': value['endAt'] === null ? null : ((value['endAt'] as any)?.toISOString()),
    };
}

